import { reducer as modal } from 'redux-modal';
import widgetState from './widgetState';
import calculatorData from './calculatorData';

const root = {
	widgetState,
	calculatorData,
	modal
};

export default root;



// WEBPACK FOOTER //
// ./src/reducers/index.js